import { Helpers } from '../../helpers';
import { IPadSize } from '../../interfaces/ipad-size';
import { ProjectDrillingParameter } from '../project-drilling-parameter';

export class PadSizeBase {
  PadSizeId: number;
  Description: string | null;
  Size: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectDrillingParameters_PadSize?: Array<ProjectDrillingParameter> | null;

  constructor(item?: IPadSize) {
    if (item) {

      this.PadSizeId = item.PadSizeId;
      this.Description = item.Description;
      this.Size = item.Size;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectDrillingParameters_PadSize = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_PadSize);
    }
  }
}